// 🎨 Importações Centralizadas dos Estilos do MessagesList
import { useMessageListStyles } from './messageListStyles';
import { useMessageItemStyles } from './messageItemStyles';
import { useReactionStyles } from './reactionStyles';
import { useQuotedMessageStyles } from './quotedMessageStyles';
import { useMessageAckStyles } from './messageAckStyles';
import { useFloatingActionsStyles } from './floatingActionsStyles';
import { useMessageBubbleStyles } from './messageBubbleStyles';
import { useMediaStyles } from './mediaStyles';

// Re-exportar para acesso direto
export { useMessageListStyles } from './messageListStyles';
export { useMessageItemStyles } from './messageItemStyles';
export { useReactionStyles } from './reactionStyles';
export { useQuotedMessageStyles } from './quotedMessageStyles';
export { useMessageAckStyles } from './messageAckStyles';
export { useFloatingActionsStyles } from './floatingActionsStyles';
export { useMessageBubbleStyles } from './messageBubbleStyles';
export { useMediaStyles } from './mediaStyles';

// 🎯 Hook Consolidado para Todos os Estilos
export const useMessageListAllStyles = () => {
  const listStyles = useMessageListStyles();
  const itemStyles = useMessageItemStyles();
  const reactionStyles = useReactionStyles();
  const quotedStyles = useQuotedMessageStyles();
  const ackStyles = useMessageAckStyles();
  const floatingStyles = useFloatingActionsStyles();
  const bubbleStyles = useMessageBubbleStyles();
  const mediaStyles = useMediaStyles();

  return {
    ...listStyles,
    ...itemStyles,
    ...reactionStyles,
    ...quotedStyles,
    ...ackStyles,
    ...floatingStyles,
    ...bubbleStyles,
    ...mediaStyles,
  };
};
